<script setup lang="ts">
// Needs to be wrapped in a <form>,
// that also handles submitting

import countries from './coutries'

const props = defineProps<{
  showFormError: boolean
  loading: boolean
  includeFileInput?: boolean
}>()

let inputs = [
  {
    type: 'text',
    label: 'Full name',
    name: 'full-name',
    required: true,
  },
  {
    type: 'email',
    label: 'Work email',
    name: 'email',
    required: true,
  },
  {
    type: 'tel',
    label: 'Phone number',
    name: 'phone',
    required: false,
  },
  {
    type: 'text',
    label: 'Company',
    name: 'company',
    required: false,
  },
  {
    type: 'select',
    label: 'Country',
    name: 'country',
    placeholder: 'Select a country',
    required: false,
    options: countries,
  },
  {
    type: 'textarea',
    label: 'Message',
    name: 'message',
    required: true,
  },
]

if (props.includeFileInput) {
  inputs.push({
    type: 'file',
    label: 'Attach a file',
    name: 'file',
    required: false,
  })
}
</script>

<template>
  <div>
    <div class="flex flex-col gap-6">
      <p class="font-display text-xl uppercase font-stretch-expanded">About you</p>

      <div v-for="(input, idx) in inputs" :key="idx">
        <CommonInputText v-if="input.type === 'text'" v-bind="input" />
        <CommonInputText v-if="input.type === 'email'" v-bind="input" />
        <CommonInputPhone v-if="input.type === 'tel'" v-bind="input" />
        <CommonInputTextarea v-if="input.type === 'textarea'" v-bind="input" />
        <CommonInputSelect v-if="input.type === 'select'" v-bind="input" />
        <CommonInputFile v-if="input.type === 'file'" v-bind="input" />
      </div>
    </div>

    <div class="input-group py-6">
      <CommonInputCheckbox
        :label="'I agree to be contacted by nitex and have my information shared with the relevant team. '"
        :name="'accepted'"
        :required="true"
      />
    </div>

    <button
      v-if="!loading"
      class="text-neon-yellow inline-block cursor-pointer bg-black p-3 font-mono text-sm uppercase"
      type="submit"
    >
      Send message
    </button>
    <div
      v-else
      class="text-neon-yellow relative inline-block cursor-wait bg-black p-3 font-mono text-sm uppercase"
    >
      <div class="loading bg-neon-yellow-60 absolute top-0 left-0 h-full w-full" />
      Sending...
    </div>
    <Transition name="clip-reveal" mode="out-in">
      <p v-if="showFormError" class="ml-auto pt-5 font-mono text-sm uppercase">
        An error occurred. Please try again.
      </p>
    </Transition>
  </div>
</template>

<style scoped>
.clip-reveal-enter-active,
.clip-reveal-leave-active {
  transition: clip-path 0.6s ease-in-out;
}

.clip-reveal-enter-from,
.clip-reveal-leave-to {
  clip-path: polygon(-100% 0%, 0% 0%, -05% 100%, -100% 100%);
}

.clip-reveal-enter-to,
.clip-reveal-leave-from {
  clip-path: polygon(-100% 0%, 105% 0%, 100% 100%, -100% 100%);
}

@keyframes loading {
  0% {
    clip-path: polygon(-100% 0%, 0% 0%, -5% 100%, -100% 100%);
  }
  50% {
    clip-path: polygon(-100% 0%, 105% 0%, 100% 100%, -100% 100%);
  }
  100% {
    clip-path: polygon(105% 0%, 110% 0%, 105% 100%, 100% 100%);
  }
}

.loading {
  animation: loading 1.2s infinite ease-in-out;
}
</style>
